import { ChangeDetectionStrategy, Component, Input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toggleIconAnim } from './toggle-icon.animations';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'lib-toggle-icon',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './toggle-icon.component.html',
  styleUrl: './toggle-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [toggleIconAnim]
})
export class ToggleIconComponent {
  @Input({ required: true }) iconInActive!: string;
  @Input({ required: true }) iconActive!: string;
  @Input({ required: true }) state!: Signal<boolean>;
}
